import { render, staticRenderFns } from "./ViewCustomerModel.vue?vue&type=template&id=1a016722"
import script from "./ViewCustomerModel.vue?vue&type=script&lang=js"
export * from "./ViewCustomerModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports